import { defineMessages } from 'react-intl';

export default defineMessages({
  fileOpenedLink: {
    id: 'components.myaccount.order.fileOpenedLink',
    defaultMessage: 'Link',
  },
  followClaimGroupLink: {
    id: 'components.myaccount.order.followClaimGroupLink',
    defaultMessage: 'Follow claimGroup',
  },
  giftProduct: {
    id: 'components.myaccount.order.giftProduct',
    defaultMessage:
      'This product is a gift, do not forget to return it with your order',
  },
});
